export default {
      id: "common__track-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__track",
      toString: function () {
        return this.url;
      }
    }